import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import * as styles from './_Spinner.scss'
import withStyles from 'isomorphic-style-loader/withStyles'
import { Row, Col } from 'react-bootstrap'

class Spinner extends Component {

  render () {
    return <div className={styles['loading-container']}>
      <FontAwesome
        className={styles['loading-spinner']}
        name='spinner'
        pulse
        size={'3x'}
      />
      <p className={styles['loading-message']}>Loading...</p>
    </div>
  }
}

export default (Spinner)
